/* eslint-disable @typescript-eslint/no-explicit-any */


import { QueryParams, StringParam, withDefault } from 'use-query-params';
import { IPaginationQueryParams, getPaginationQueryParams } from '../common/constants/pagination';
import { OrderDirection } from '../common/enums/order-direction.enum';
import RequestTable from './RequestTable';
import { RequestStatusEnum } from '../common/enums/request-status.enum';
import { IHOCQueryProps } from '../common/interfaces/IHOCQueryProps';

export interface RequestTableQueryPrps extends IPaginationQueryParams {
  search?: string;
  status?: RequestStatusEnum;
  year?: string;
  month?: string;
}

export type RequestTableBasicProps = IHOCQueryProps<RequestTableQueryPrps>;

const DEFAULT_QUERY_PARAMS = getPaginationQueryParams({
  orderBy: 'created_at',
  orderDirection: OrderDirection.DESC,
});

const RequestTableWithQueryParams = ({ year, month }: { year?: string, month?: string }) => {
  const queryConfig = {
    ...DEFAULT_QUERY_PARAMS,
    search: StringParam,
    status: StringParam,
    year: withDefault(StringParam, year || ''),
    month: withDefault(StringParam, month || ''),
  };

  return (
    <QueryParams config={queryConfig}>
      {(props: any) => {
        return <RequestTable {...props} />;
      }}
    </QueryParams>
  );
};

export default RequestTableWithQueryParams;
